// extracted by mini-css-extract-plugin
export default {"title":"messageModal_title__i2rFe","inputWrap":"messageModal_inputWrap__1lUkj","button":"messageModal_button__t9aGm","textarea":"messageModal_textarea__-uOjb"};